import _toConsumableArray from "/builds/mosano/marketing/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { distance } from "./math.js";
export default function (ring, vs) {
  var len = ring.length,
      min = Infinity,
      bestOffset,
      sumOfSquares,
      spliced;

  var _loop = function _loop(offset) {
    sumOfSquares = 0;
    vs.forEach(function (p, i) {
      var d = distance(ring[(offset + i) % len], p);
      sumOfSquares += d * d;
    });

    if (sumOfSquares < min) {
      min = sumOfSquares;
      bestOffset = offset;
    }
  };

  for (var offset = 0; offset < len; offset++) {
    _loop(offset);
  }

  if (bestOffset) {
    spliced = ring.splice(0, bestOffset);
    ring.splice.apply(ring, [ring.length, 0].concat(_toConsumableArray(spliced)));
  }
}